import { BORDER_COLORS as BC, SURFACE_COLORS as SC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

import { STATUS_TYPE } from '../constants.ts';
import type { StatusType } from '../types.ts';

const getStatusWrapperColors = (type: StatusType) => {
    switch (type) {
        case STATUS_TYPE.SUCCESS:
            return { border: BC.success, background: SC.success };
        case STATUS_TYPE.FAILURE:
            return { border: BC.error, background: SC.error };
        case STATUS_TYPE.IN_PROGRESS:
        default:
            return { border: BC.warning, background: SC.warning };
    }
};

export const TableStatusWrapper = styled.div<{ type: StatusType }>`
    display: flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 48px;
    width: fit-content;

    ${({ type }) => {
        const { border, background } = getStatusWrapperColors(type);

        return `
            border: 1px solid ${border};
            background: ${background};
        `;
    }}
`;

export const Title = styled.div<{ type: StatusType }>`
    color: ${({ type }) =>
        type === STATUS_TYPE.SUCCESS ? TC.success : type === STATUS_TYPE.FAILURE ? TC.error : TC.warning};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontWeight};
`;
